import { render, staticRenderFns } from "./WatchLive.vue?vue&type=template&id=185cd510"
import script from "./WatchLive.vue?vue&type=script&lang=js"
export * from "./WatchLive.vue?vue&type=script&lang=js"
import style0 from "./WatchLive.vue?vue&type=style&index=0&id=185cd510&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports